import axios from '@/plugins/Axios'
import Mapper from './Mapper'

function Requests () {
  async function fetchBuyerOrders(params) {
    try {
      const { data } = await axios.get('/order', { params })
      return data.orders.map(order => Mapper.order(order))
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchOrderInfo(id) {
    try {
      const { data } = await axios.get(`/order/${id}`)
      const supportData = await fetchOrderSupportTickets(id)
      if (data.result) return Mapper.orderDetail(data.order, supportData)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function fetchOrderSupportTickets(id) {
    try {
      const { data } = await axios.get(`/order/${id}/support-tickets`)
      if (data.result) return Mapper.orderSupportTickets(data.tickets)
      return data
    } catch (error) {
      return []
    }
  }

  async function fetchOrderInvoice(id) {
    try {
      const { data } = await axios.get(`/order/generate-invoice/${id}`, { responseType: 'blob' })
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function cancelOrder(payload) {
    try {
      const { data } = await axios.post(`/cancel-order/${payload.id}`, payload.formData)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function openServiceRequest(payload) {
    try {
      const { data } = await axios.post(`/service-request/${payload.id}`, payload.formData)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function fetchDraftOrdersRequest() {
    try {
      const { data } = await axios.get(`sourcing/sourcing-requests/draft`)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function deleteDraftOrdersRequest(id_token) {
    try {
      const { data } = await axios.delete(`sourcing/sourcing-requests/draft/${id_token}`)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function deleteAllDrafts() {
    try {
      const { data } = await axios.delete(`sourcing/sourcing-requests/draft`)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function fetchSourcingOrderInfoRequest(payload) {
    try {
      const { data } = await axios.get(`/sourcing/sourcing-request/${payload}`)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  return {
    fetchBuyerOrders,
    fetchOrderInfo,
    cancelOrder,
    openServiceRequest,
    fetchOrderInvoice,
    fetchDraftOrdersRequest,
    deleteDraftOrdersRequest,
    deleteAllDrafts,
    fetchSourcingOrderInfoRequest
  }
}

export default Requests()